
import { getUrlParam } from "./getValue"
import { getStorage, setStorage } from "./onStorage"

export const getTrackerInstance = () => {
  return window.dpTracker
}

// user_id: memberCode
export const TrackLogin = (identifyParams: { user_id: string, [key: string]: any }, publicParams: { guest_code: string, [key: string]: any }) => {
  try {
    if (!identifyParams.user_id) return
    // 确保已登出，需先调用logout 才能埋点登录
    window.dpTracker?.anonymous()
    let openId = getUrlParam('openId') || identifyParams.identity_mp_openid || ''
    const openIdFromLocal = getStorage('openId') || ''
    if(openId && openId !== openIdFromLocal) {
      setStorage('openId', openId)
      openId = openIdFromLocal
    }
    const tracker = getTrackerInstance()
    if (!tracker) return
    if (publicParams) {
      tracker?.setPublicParams({
        ...publicParams,
      })
    }
    tracker?.identify({
      identity_mp_openid: openId,
      ...identifyParams,
    })
  }catch(err) {
    console.error('TrackLogin error', err)
  }
}
